import React from 'react';
import './Blogs.css';
import { FaMedium } from 'react-icons/fa';

const blogs = [
  {
    title: "Geopolitical Tensions, Market Volatility, and the Case for Gold and Silver ETFs",
    platform: "Medium",
    icon: <FaMedium />,
    link: "https://medium.com/@usernamenikhilsharma/geopolitical-tensions-and-gold-why-smaunderstanding-how-global-conflicts-and-political-uncertainty-de0840341945",
    description: "Exploring how geopolitical uncertainty shapes precious metals markets and portfolio diversification.",
  },
  {
    title: "Netflix’s $72B Warner Bros Acquisition: A Finance Deep-Dive Recruiters Will Love",
    platform: "Medium",
    icon: <FaMedium />,
    link: "https://medium.com/@usernamenikhilsharma/netflixs-72b-warner-bros-acquisition-a-finance-deep-dive-recruiters-will-love-c7004b439dc6",
    description: "A finance-focused deep dive into Netflix’s $72B Warner Bros acquisition.",
  },
  {
    title: "Canadian Fixed Income Market Analysis: 2025 Outlook, Yields & Investment Strategies",
    platform: "Medium",
    icon: <FaMedium />,
    link: "https://medium.com/@usernamenikhilsharma/canadian-fixed-income-market-analysis-2025-outlook-yields-investment-strategies-b533212d29f7",
    description: "An overview of Canada’s fixed income market, covering the 2025 outlook, yields, and investment strategies.",
  },
];

const Blogs: React.FC = () => {
  return (
    <div className="blogs-container">
      <h2 className="blogs-title">✍️ My Blog Posts</h2>
      <p className="blogs-intro">My perspectives on finance, investment strategies, and global markets.</p>
      <div className="blogs-grid">
        {blogs.map((blog, index) => (
          <a href={blog.link} key={index} target="_blank" rel="noopener noreferrer" className="blog-card" style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}>
            <div className="blog-icon animated-icon">{blog.icon}</div>
            <div className="blog-info animated-text">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              <span className="blog-platform">{blog.platform}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
